import TableNavigate from "./TableNavigate"

export default {
    mixins: [TableNavigate],

    url: '/api/dossiers',

    methods: {
        /**
         * Exporte le tableau en xls
         */
        exportExcel: function () {
            let unique = (new Date()).getTime()
            window.open(`/api/dossiers/export-excel?uniquefile?=${unique}&${$.param(this.exParams)}`, '_blank')
        }
    }
}
